const GENDER_OPTIONS = ["Male", "Female", "Non-binary"];

const GenderModal = ({ filters, setFilters, onClose }) => {
  const selected = filters.gender || "";

  const handleSelect = (value) => {
    setFilters({
      ...filters,
      gender: value === selected ? "" : value,
    });
  };

  return (
    <div className="w-full relative mt-2">
      {/* Arrow Pointer */}
      <div className="absolute -top-5 left-10 w-4 h-4 bg-white rotate-45 border-l border-t"></div>

      <h2 className="text-lg font-semibold mb-4">Gender</h2>

      <div className="space-y-3 mb-3 max-h-[220px] overflow-y-auto pr-1">
        {GENDER_OPTIONS.map((opt) => (
          <label key={opt} className="flex items-center gap-3 cursor-pointer">
            <input
              type="checkbox"
              className="w-4 h-4"
              checked={selected === opt}
              onChange={() => handleSelect(opt)}
            />
            <span className="text-sm">{opt}</span>
          </label>
        ))}
      </div>

      <div className="flex justify-between gap-6 mt-2 border-t pt-2">
        <button
          onClick={() => {
            setFilters({ ...filters, gender: "" });
            onClose();
          }}
          className="underline text-sm text-gray-700 hover:text-gray-900"
        >
          Clear
        </button>
        <button
          onClick={onClose}
          className="bg-orange-500 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-orange-600 transition"
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default GenderModal;




// const GenderModal = ({ filters, setFilters, onClose }) => {
//     return (
//       <>
//         <select
//           className="w-full border rounded-xl px-4 py-4 text-lg"
//           value={filters.gender}
//           onChange={(e) =>
//             setFilters({ ...filters, gender: e.target.value })
//           }
//         >
//           <option value="">Choose a gender</option>
//           <option>Male</option>
//           <option>Female</option>
//           <option>Non-binary</option>
//         </select>
  
//         <div className="flex justify-between mt-6">
//           <button
//             onClick={() => setFilters({ ...filters, gender: "" })}
//             className="underline"
//           >
//             Clear
//           </button>
//           <button
//             onClick={onClose}
//             className="bg-black text-white px-8 py-3 rounded-xl"
//           >
//             Save
//           </button>
//         </div>
//       </>
//     );
//   };
  
//   export default GenderModal;
  